import { render } from "./ModalDescription.vue?vue&type=template&id=1d1e3f3c&scoped=true"
import script from "./modal-description-component.ts?vue&type=script&lang=js&external"
export * from "./modal-description-component.ts?vue&type=script&lang=js&external"

import "@scss/modal.scss?vue&type=style&index=0&id=1d1e3f3c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1e3f3c"]])

export default __exports__